import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/pro-light-svg-icons";
import { faRotateLeft as solidRotate } from "@fortawesome/pro-regular-svg-icons";
import s from "./filter.module.css";
import { useContext, useEffect, useState } from "react";
import QueryContext from "state/query";
import { useGTM } from "hooks";

export default function ResetFilters() {
  const { countries, technologies, statuses, resetSelection } =
    useContext(QueryContext);
  const [isActive, setIsActive] = useState(false);
  const { dataLayer } = useGTM();

  useEffect(() => {
    setIsActive(countries.length || technologies.length || statuses.length);
  }, [countries, technologies, statuses]);

  return (
    <div
      className={`${s.clickable} ${
        !isActive ? "text-gray-300" : ""
      } bg-gray-50 w-[65px] sm:w-full hover:bg-primary-200 group`}
      onClick={(e) => {
        if (isActive) {
          dataLayer.push({
            event: "cefic_gip_map.filters.reset.click",
          });
        }
        resetSelection(e);
      }}
    >
      <p className={`${s.icon} group-hover:hidden`}>
        <FontAwesomeIcon icon={faRotateLeft} />
      </p>
      <p className={`${s.icon} hidden group-hover:inline-block`}>
        <FontAwesomeIcon icon={solidRotate} />
      </p>
      <p className={`${s.name}`}>Reset</p>
    </div>
  );
}
